<script setup lang="ts">
import { computed, ref, watchEffect } from 'vue'
import { displayName } from '../lib/format'
import { formatSafetyNumber, safetyNumber } from '../lib/safety'
import { useSession } from '../stores/session'
import Modal from './Modal.vue'

const props = defineProps<{ userId: string }>()
const emit = defineEmits<{ close: [] }>()
const session = useSession()
const digits = ref<string | null>(null)
const name = computed(() => displayName(session.profiles, props.userId))

watchEffect(async () => {
  const devices = session.sync?.devices ?? []
  const mine = devices.find((d) => d.user_id === session.me)
  const theirs = devices.find((d) => d.user_id === props.userId)
  digits.value = mine && theirs ? await safetyNumber(mine, theirs) : null
})
</script>

<template>
  <Modal :title="`Verify ${name}`" @close="emit('close')">
    <div v-if="digits" class="space-y-4">
      <div class="field-grid grid grid-cols-4 gap-px border border-border p-4 text-center font-mono text-lg tracking-[0.15em]" data-testid="safety-number">
        <span v-for="(g, i) in formatSafetyNumber(digits)" :key="i">{{ g }}</span>
      </div>
      <p class="text-sm text-text-muted">
        Compare these numbers with {{ name }} in person or on a call. If they match on both phones, your
        conversations are end-to-end encrypted with the right people — nobody, not even the server, is in the
        middle.
      </p>
      <p class="text-xs text-text-muted">
        The number changes when either of you adds or removes a device. You'll see a notice in your chats when that
        happens.
      </p>
    </div>
    <p v-else class="text-sm text-text-muted">Loading keys…</p>
  </Modal>
</template>
